








































































import Vue from "vue";
import {
  required,
  integer,
  minValue,
  minLength,
  requiredIf
} from "vuelidate/lib/validators";

import PromotionGroupCard from "../components/PromotionGroupCard.vue";
import {
  PromotionDetailForm,
  PromotionItemGroupForm,
  PromotionItemStatus,
  PromotionItemForm,
  PromotionConditionPriceForm
} from "../forms/PromotionDetailForm";
import { Shop } from "../../shop/models/Shop";
import { Channel } from "../../channel/models/Channel";

export default Vue.extend({
  components: {
    PromotionGroupCard
  },
  validations: {
    promotionDetailForm: {
      name: { required },
      shop: { required },
      startDate: { required },
      promotionGroup: {
        channelsSelected: {
          required,
          minLength: minLength(1)
        },
        conditionItemGroups: {
          $each: {
            items: {
              required: requiredIf(function(this: any) {
                return this.isConditionTypeProduct;
              }),
              minLength: minLength(1),
              $each: {
                status: {
                  sameAs: function(status: any) {
                    return status === PromotionItemStatus.Success;
                  }
                }
              }
            }
          }
        },
        promotionItemGroups: {
          $each: {
            items: {
              required: requiredIf(function(this: any) {
                return this.isConditionTypeProduct;
              }),
              minLength: minLength(1),
              $each: {
                status: {
                  sameAs: function(status: any) {
                    return status === PromotionItemStatus.Success;
                  }
                }
              }
            }
          }
        },
        promotionConditionPrices: {
          $each: {
            price: { required, minValue: minValue(0) },
            promotionItemGroups: {
              $each: {
                items: {
                  required: requiredIf(function(this: any) {
                    return this.isConditionTypePrice;
                  }),
                  minLength: minLength(1),
                  $each: {
                    status: {
                      sameAs: function(status: any) {
                        return status === PromotionItemStatus.Success;
                      }
                    }
                  }
                }
              }
            }
          }
        },
        orderLimit: {
          required,
          integer,
          minValue: minValue(0)
        }
      }
    }
  },
  data() {
    const shops: Shop[] = [];
    const channels: Channel[] = [];
    const isLoading = false;
    const initeData: any = {};
    const promotionDetailForm: PromotionDetailForm = {
      name: "",
      promotionGroup: {
        channelsSelected: [],
        conditionType: "PRODUCT",
        conditionItemGroups: [{ items: [] }],
        promotionItemGroups: [{ items: [] }],
        promotionConditionPrices: [
          { price: 0, promotionItemGroups: [{ items: [] }] }
        ],
        orderLimit: 0,
        promotionHold: false
      }
    };

    return {
      shops,
      channels,
      isLoading,
      initeData,
      promotionDetailForm
    };
  },
  computed: {
    shopOptions() {
      return (this as any).shops;
    },
    channelOptions() {
      return (this as any).channels;
    },
    isConditionTypeProduct() {
      return (
        (this as any).promotionDetailForm.promotionGroup.conditionType ===
        "PRODUCT"
      );
    },
    isConditionTypePrice() {
      return (
        (this as any).promotionDetailForm.promotionGroup.conditionType ===
        "PRICE"
      );
    },
    nameError() {
      return (this as any).$v.promotionDetailForm.name.$error
        ? "ชื่อ Promotion is required"
        : "";
    },
    shopError() {
      return (this as any).$v.promotionDetailForm.shop.$error
        ? "ร้าน is required"
        : "";
    },
    startDateError() {
      return (this as any).$v.promotionDetailForm.startDate.$error
        ? "วันเริ่ม is required or invalid"
        : "";
    }
  },
  async created() {
    await Promise.all([this.getShops(), this.getChannels()]);
    await this.getPromotionById(+this.$route.params.id);
  },
  methods: {
    goToPromotionViewPage() {
      this.$router.push({ name: "PromotionViewPage" });
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getChannels() {
      try {
        const { data } = await (this as any).$dep.channelUseCase.getChannels({
          perPage: 9999
        });
        this.channels = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getPromotionById(id: number) {
      try {
        const { data } = await (this as any).$dep.promotionUseCase.getPromotion(
          id
        );
        this.promotionDetailForm = (this as any).$dep.promotionUseCase.presentPromtionForm(
          data
        );
        const shop = await this.shops.find(shop => {
          return shop.id === data.shopId;
        });
        this.promotionDetailForm = { ...this.promotionDetailForm, shop };
      } catch (error) {
        console.log(error);
      }
    }
  }
});
